import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { type FC, type ReactNode, useCallback, useEffect, useState } from 'react'

interface Step {
    title: string
    description: ReactNode
    image: string
}

const steps: Step[] = [
    {
        title: 'Title',
        description: 'Lorem ipsum dolor sit amet consectetur. Ultrices molestie elit imperdiet dui lobortis quis dui.',
        image: '/onboarding.png',
    },
    {
        title: 'Title',
        description: 'Lorem ipsum dolor sit amet consectetur. Ultrices molestie elit imperdiet dui lobortis quis dui.',
        image: '/onboarding.png',
    },
    {
        title: 'Title',
        description: 'Lorem ipsum dolor sit amet consectetur. Ultrices molestie elit imperdiet dui lobortis quis dui.',
        image: '/onboarding.png',
    },
]

interface Props {
    onOpenChange: (open: boolean) => void
    open?: boolean
    onFinish: () => void
}

export const OnboardingDialog: FC<Props> = ({ onOpenChange, open, onFinish }) => {
    const [currentStepIndex, setCurrentStepIndex] = useState(0)

    const hasNextStep = currentStepIndex < steps.length - 1
    const hasPreviousStep = currentStepIndex > 0

    const currentStep = steps[currentStepIndex]

    const handleNextStep = useCallback(() => {
        if (hasNextStep) {
            setCurrentStepIndex(currentStepIndex + 1)
        } else {
            onFinish()
        }
    }, [hasNextStep, currentStepIndex, onFinish])

    const handlePreviousStep = useCallback(() => {
        if (hasPreviousStep) {
            setCurrentStepIndex(currentStepIndex - 1)
        }
    }, [hasPreviousStep, currentStepIndex])

    useEffect(() => {
        if (open) {
            setCurrentStepIndex(0)
        }
    }, [open])

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent
                closeButtonClassName="hidden"
                onInteractOutside={(event) => {
                    event.preventDefault()
                }}
            >
                <DialogHeader>
                    <DialogTitle className="hidden">Onboarding</DialogTitle>
                    <DialogDescription className="hidden">Onboarding</DialogDescription>
                </DialogHeader>
                <div className="flex flex-col gap-8 items-center justify-center">
                    <div className="flex flex-col gap-6">
                        <section className="w-full border rounded-2xl border-white/40 overflow-hidden">
                            <img src="/onboarding.png" alt="Onboarding" className="w-full" />
                        </section>
                        <section className="flex flex-col gap-3 items-center justify-center">
                            <span className="text-sm">
                                {currentStepIndex + 1}/{steps.length}
                            </span>
                            <h2>{currentStep.title}</h2>
                            <span className="text-sm text-center">{currentStep.description}</span>
                        </section>
                    </div>
                    <div className="flex flex-row gap-4">
                        {hasPreviousStep && (
                            <Button variant="secondary" className="grow-0 shrink" onClick={handlePreviousStep}>
                                Back
                            </Button>
                        )}
                        <Button className="grow-0 shrink" onClick={handleNextStep}>
                            Next
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    )
}
